
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
// import AnimatedCursor from "react-animated-cursor"
import Login from './pages/components/Login';
import Home from './pages/web/home';
import UserList from './pages/components/UserList'
import Dashboard from './pages/Dashboard';
import NotFound from './pages/components/NotFound';
import UserDetail from './pages/components/UserDetail';
import Settings from './pages/Settings';
import Register from './pages/components/Register';
// import Announcement from './pages/Announcement';
// import AdsSettings from './pages/components/AdsSettings';
import { Toaster } from 'react-hot-toast';
// import WeeklyLeaderboard from './pages/components/Weekly-leaderboard';
// import PioneerList from './pages/PioneerList';
// import PioneerEmailEditor from './pages/components/PioneerEmailEditor';
import Notifications from './pages/notifications';
import UserChartPage from './pages/components/UserChartPage';
import GamesPage from './pages/GamesPage';
import GamePlan from './pages/GamePlan';
import History from './pages/History';
import TaskPage from './pages/TaskPage';
import TaskHistoryPage from './pages/TaskHistoryPage';
import Sidebar from './pages/components/Sidebar';
import Navbar from './pages/components/Navbar';

function App() {

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/home" />;
  };
  
  return (
    <>
    <Toaster position="top-right" />
      <Router>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
            <Route path="/user/:id" element={<ProtectedRoute><UserDetail /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/games" element={<ProtectedRoute><GamesPage /></ProtectedRoute>} />
            <Route path="/game-plan" element={<ProtectedRoute><GamePlan /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><TaskPage /></ProtectedRoute>} />
            <Route path="/tasks/:id/history" element={<ProtectedRoute><TaskHistoryPage /></ProtectedRoute>} />
            {/* <Route path="/weekly-leaderboard" element={<WeeklyLeaderboard />} /> */}
            {/* <Route path="/pioneer-list" element={<PioneerList />} /> */}
            {/* <Route path="/pioneer-email" element={<PioneerEmailEditor />} /> */}
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/chart" element={
              <ProtectedRoute>
                <div className="flex flex-col md:flex-row bg-gray-900 min-h-screen">
                  <Sidebar />
                  <div className="flex-1 flex flex-col min-w-0">
                    <Navbar />
                    <UserChartPage />
                  </div>
                </div>
              </ProtectedRoute>
            } />
            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
            {/* <Route path="/ads-settings" element={<AdsSettings />} /> */}
        </Routes>
      </Router>
            
    {/* <AnimatedCursor 
      innerSize={10}
      outerSize={20}
      color='70, 70, 229'
      outerAlpha={0.2}
      innerScale={1}
      outerScale={5}
    /> */}
    </>
  );
}

export default App;
